import { useEffect, useRef, useState } from "react";
import { motion, useInView, animate } from "framer-motion";
import { TID } from "@/lib/testIds";

const STATS = [
  { value: 25000, suffix: "+", label: "Files ausgeliefert" },
  { displayValue: "20–30", suffix: " Min", label: "Ø Bearbeitungszeit" },
  { value: 12000, suffix: "+", label: "Unterstützte Steuergeräte" },
  { value: 23, suffix: " Jahre", label: "Erfahrung im Tuning" },
];

function Counter({ value }) {
  const ref = useRef(null);
  const inView = useInView(ref, { once: true, margin: "-60px" });
  const [display, setDisplay] = useState(0);

  useEffect(() => {
    if (!inView) return;
    const controls = animate(0, value, {
      duration: 1.6,
      ease: [0.16, 1, 0.3, 1],
      onUpdate: (v) => setDisplay(Math.floor(v)),
    });
    return () => controls.stop();
  }, [inView, value]);

  return <span ref={ref}>{display.toLocaleString("de-DE")}</span>;
}

export default function Stats() {
  return (
    <section id="stats-section" data-testid={TID.stats.root} className="border-b border-white/10">
      <div className="max-w-7xl mx-auto px-5 md:px-10 py-16 md:py-20 grid grid-cols-2 lg:grid-cols-4 gap-y-12 gap-x-6">
        {STATS.map((s, i) => (
          <motion.div
            key={i}
            initial={{ opacity: 0, y: 24 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-60px" }}
            transition={{ duration: 0.6, delay: i * 0.08 }}
            className="flex flex-col"
          >
            <div className="font-display font-bold text-4xl md:text-5xl lg:text-6xl text-white tracking-tight">
              {s.displayValue ?? <Counter value={s.value} />}
              <span className="text-primary">{s.suffix}</span>
            </div>
            <div className="mt-3 text-xs md:text-sm uppercase tracking-widest text-white/45">
              {s.label}
            </div>
          </motion.div>
        ))}
      </div>
    </section>
  );
}
